import { getDataQueue } from 'RestAPIs/data-queue';

import { BaseQueue } from 'components/admin-portal/queues/BaseQueue';

const DataQueue = () => {
  const columns = [
    'id',
    'tenantId',
    'requestClass',
    'status',
    'inserted',
    'started',
    'ended'
  ];

  return (
    <BaseQueue
      queueName="dataQueue"
      columns={columns}
      getBaseQueue={getDataQueue}
      rowMapper={(o) => ({
        ...o,
        requestClass: o.requestClass?.split('.').pop()
      })}
    />
  );
};

export default DataQueue;
